import { setAlert } from '../../alert';
import { getConfig, getFormDataConfig } from '../constants/00-base-constants';
import {
    GET_PACKAGING_MATERIALS_DATA_SUCCESS,
    GET_PACKAGING_MATERIALS_DATA_FAIL,
    POST_PACKAGING_MATERIALS_DATA_SUCCESS,
    POST_PACKAGING_MATERIALS_DATA_FAIL,
    GET_PACKAGING_MATERIALS_DATA_TOTALS_SUCCESS,
    GET_PACKAGING_MATERIALS_DATA_TOTALS_FAIL
} from '../types/04-indirect-ghg-emissions-from-products-used-by-an-organisation';
import {
    API_GET_PACKAGING_MATERIALS,
    API_POST_PACKAGING_MATERIALS,
    API_GET_PACKAGING_MATERIALS_TOTALS
} from '../constants/04-indirect-ghg-emissions-from-products-used-by-an-organisation';
import api from '../../../util/api';

export const postPackagingMaterialsData = (formData, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_PACKAGING_MATERIALS + `/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            getFormDataConfig()
        );
        dispatch({
            type: POST_PACKAGING_MATERIALS_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_PACKAGING_MATERIALS_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getPackagingMaterialsData = (year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_PACKAGING_MATERIALS + `/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            getConfig()
        );
        dispatch({
            type: GET_PACKAGING_MATERIALS_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_PACKAGING_MATERIALS_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getPackagingMaterialsDataTotals = (year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_PACKAGING_MATERIALS_TOTALS + `/${year}/${facility}`,
            getConfig()
        );
        dispatch({
            type: GET_PACKAGING_MATERIALS_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_PACKAGING_MATERIALS_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};